<template>
  <div class="new-shipment-handling-driver">
    <label
      data-test="label"
    >
      {{ $t('new-shipment.labels.handling') }}
    </label>
    <div
      class="tw-flex new-shipment-handling-driver__buttons"
      data-test="buttons"
    >
      <new-shipment-handling-button
        :icon="'client'"
        :title="$t(`new-shipment.values.handling.${direction}.shipper`)"
        :subtitle="direction === 'pickup' ? $t('new-shipment.values.handling.pickup.shipper_subtitle') : null"
        :active="selectedValue === 'shipper'"
        :class="{
          'has-error': !!error
        }"
        data-test="shipper"
        class="mr-3 tw-flex-1"
        @click.native="selectedValue = 'shipper'"
      />
      <new-shipment-handling-button
        :icon="'driver'"
        :title="$t('new-shipment.values.handling.carrier')"
        :active="selectedValue === 'carrier'"
        :class="{
          'has-error': !!error
        }"
        data-test="carrier"
        class="tw-flex-1"
        @click.native="selectedValue = 'carrier'"
      />
    </div>
  </div>
</template>

<script>
  import { defineComponent } from '@vue/composition-api'

  import useModelGetterSetter from '@/composables/useModelGetterSetter'

  import NewShipmentHandlingButton from './../../../NewShipmentHandlingButton/index.vue'

  /**
   * @module component - NewShipmentHandlingDriver
   * @param {string} direction
   * @param {string} [error=null]
   */
  export default defineComponent({
    name: 'NewShipmentHandlingDriver',
    props: {
      value: {
        type: String,
        default: null
      },
      direction: {
        type: String,
        required: true
      },
      error: {
        type: String,
        default: null
      }
    },
    components: {
      NewShipmentHandlingButton
    },
    setup (props) {
      const { state: selectedValue } = useModelGetterSetter(props, 'value')

      return {
        selectedValue
      }
    }
  })
</script>

<style lang="scss" scoped>
  .new-shipment-handling-driver {
    .new-shipment-handling-button {
      width: 50%;

      &.has-error {
        border: 1px solid $danger;
      }
    }

    @media only screen and (max-width: $breakpoint-mobile-s) {
      &__buttons {
        flex-direction: column;

        .new-shipment-handling-button {
          width: 100%;

          &:first-child {
            margin-bottom: 16px;
          }
        }
      }
    }
  }
</style>
